export const onMessageRead = (channel, callback) => {
    channel.on('message.read', callback);
};
